<template>
  <div justify="center">
    <v-card flat>
      <v-card-title class="pa-0 pt-4 pl-5">
        <span>กำหนดเวลาทำแบบสอบถาม</span>
      </v-card-title>
      <v-card-title class="pa-0 pt-2 pl-5 pb-4">
        <img src="../../assets/img/linemd.png" width="60px" />
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-checkbox
            v-model="surveyform.enableSchedule"
            label="กำหนดเวลา"
            :disabled="menu_start || menu_end || !SPermission.update"
            @change="ClearTime"
          ></v-checkbox>
          <v-card flat v-if="surveyform.enableSchedule">
            <v-row no-gutters>
              <v-col
                cols="12"
                sm="6"
                class="d-flex justify-center align-center"
              >
                <v-menu
                  ref="menu_s"
                  v-model="menu_start"
                  :close-on-content-click="false"
                  :return-value.sync="date_start"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="
                        !date_start
                          ? ''
                          : $store.getters.dateConvertShort(date_start)
                      "
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="pt-0"
                      label="วันที่เริ่มแบบสอบถาม"
                      outlined
                      dense
                      :disabled="!SPermission.update"
                      :rules="textRule"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_start"
                    no-title
                    scrollable
                    :min="today"
                    locale="th"
                    @input="StartSave"
                  >
                  </v-date-picker> </v-menu
              ></v-col>
              <v-col cols="12" sm="6" class="d-flex justify-center align-center"
                ><v-card class="d-flex flex-wrap" flat tile>
                  <v-card class="py-0 mx-2 mt-2" flat tile
                    ><v-icon>schedule</v-icon></v-card
                  >
                  <v-card
                    class="py-0 mx-1 align-self-center"
                    flat
                    tile
                    width="80"
                  >
                    <v-select
                      v-model="start_h"
                      :rules="textRule"
                      :items="hour_start"
                      dense
                      :disabled="!SPermission.update"
                      outlined
                      class="rounded"
                      @input="DateStartFormat"
                    ></v-select>
                  </v-card>
                  <v-card class="py-0 mx-1 mt-2" flat tile width="1">:</v-card>
                  <v-card
                    class="py-0 mx-1 align-self-center"
                    flat
                    tile
                    width="80"
                  >
                    <v-select
                      v-model="start_m"
                      :rules="textRule"
                      :items="min_start"
                      dense
                      :disabled="!SPermission.update"
                      outlined
                      class="rounded"
                      @input="DateStartFormat"
                    ></v-select>
                  </v-card>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="d-flex justify-center align-center"
              >
                <v-menu
                  ref="menu_e"
                  v-model="menu_end"
                  :close-on-content-click="false"
                  :return-value.sync="date_end"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="
                        !date_end
                          ? ''
                          : $store.getters.dateConvertShort(date_end)
                      "
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="pt-0"
                      label="วันที่จบแบบสอบถาม"
                      outlined
                      dense
                      :disabled="!SPermission.update"
                      :rules="textRule"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_end"
                    no-title
                    scrollable
                    :min="date_start"
                    locale="th"
                    @input="EndSave"
                  >
                  </v-date-picker> </v-menu
              ></v-col>
              <v-col cols="12" sm="6" class="d-flex justify-center align-center"
                ><v-card class="d-flex flex-wrap" flat tile>
                  <v-card class="py-0 mx-2 mt-2" flat tile
                    ><v-icon>schedule</v-icon></v-card
                  >
                  <v-card
                    class="py-0 mx-1 align-self-center"
                    flat
                    tile
                    width="80"
                  >
                    <v-select
                      v-model="end_h"
                      :rules="textRule"
                      :items="hour_end"
                      :disabled="AllowEndTime || !SPermission.update"
                      dense
                      outlined
                      class="rounded"
                      @input="DateEndFormat"
                    ></v-select>
                  </v-card>
                  <v-card class="py-0 mx-1 mt-2" flat tile width="1">:</v-card>
                  <v-card
                    class="py-0 mx-1 align-self-center"
                    flat
                    tile
                    width="80"
                  >
                    <v-select
                      v-model="end_m"
                      :rules="textRule"
                      :items="min_end"
                      :disabled="AllowEndTime || !SPermission.update"
                      dense
                      outlined
                      class="rounded"
                      @input="DateEndFormat"
                    ></v-select>
                  </v-card>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// import Swal from "sweetalert2";
export default {
  props: ["surveyform"],
  data: () => ({
    dialog: false,
    menu_start: false,
    date_start: null,
    menu_end: false,
    date_end: null,
    today: new Date().toISOString().substr(0, 10),
    textRule: [(v) => !!v || "กรุณากรอกข้อมูล"],
    hour_start: [],
    min_start: [],
    hour_end: [],
    min_end: [],
    min: [2, 3, 4, 5, 6, 7, 8, 9, 10],
    max: [2, 3, 4, 5, 6, 7, 8, 9, 10],
    start_h: "00",
    start_m: "00",
    end_h: "00",
    end_m: "01",
  }),
  mounted() {
    for (let index = 0; index < 24; index++) {
      this.hour_start.push(index < 10 ? "0" + index : index + "");
      this.hour_end.push(index < 10 ? "0" + index : index + "");
    }
    for (let index = 0; index < 60; index++) {
      this.min_start.push(index < 10 ? "0" + index : index + "");
      this.min_end.push(index < 10 ? "0" + index : index + "");
    }
  },
  watch: {
    surveyform: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && oldValue) {
          if (newValue.surveyDatetimeStart && newValue.surveyDatetimeEnd) {
            if (newValue.surveyDatetimeStart !== oldValue.surveyDatetimeStart) {
              this.date_start = newValue.surveyDatetimeStart.split("T")[0];
              this.date_end = newValue.surveyDatetimeEnd.split("T")[0];
              if (+this.date_start.split("-")[2] < 10) {
                this.date_start = `${this.date_start.split("-")[0]}-${
                  this.date_start.split("-")[1]
                }-0${this.date_start.split("-")[2]}`;
              }
              if (+this.date_end.split("-")[2] < 10) {
                this.date_end = `${this.date_end.split("-")[0]}-${
                  this.date_end.split("-")[1]
                }-0${this.date_end.split("-")[2]}`;
              }
              this.start_h = newValue.surveyDatetimeStart
                .split("T")[1]
                .split(":")[0];
              this.start_m = newValue.surveyDatetimeStart
                .split("T")[1]
                .split(":")[1];
              this.end_h = newValue.surveyDatetimeEnd
                .split("T")[1]
                .split(":")[0];
              this.end_m = newValue.surveyDatetimeEnd
                .split("T")[1]
                .split(":")[1];
              if (
                `${this.date_start}T${this.start_h}:${this.start_m}` ===
                `${this.date_end}T${this.end_h}:${this.end_m}`
              ) {
                this.date_start = null;
                this.date_end = null;
                this.start_h = "00";
                this.end_h = "00";
                this.start_m = "00";
                this.end_m = "01";
              }
            }
          }
        }
      },
    },
  },
  computed: {
    SPermission() {
      return this.$store.state.user_permission.survey;
    },
    ButtonLoading() {
      return this.$store.state.button_loading;
    },
    AllowEndTime() {
      var a;
      let vm = this;
      if (this.start_h && this.start_m) {
        if (
          new Date(this.date_start).getTime() ===
          new Date(this.date_end).getTime()
        ) {
          let filterH = this.hour_start.filter((a) => a >= this.start_h);
          vm.hour_end = filterH;
          if (vm.start_m >= vm.end_m) {
            if (this.start_m === "59") {
              vm.hour_end.shift();
            }
          }
          if (vm.start_h > vm.end_h) {
            vm.end_h = vm.start_h;
          }
          if (vm.start_h === vm.end_h) {
            if (vm.start_m >= vm.end_m) {
              let filterM = this.min_start.filter((a) => a > this.start_m);
              vm.min_end = filterM;
              if (this.start_m === "59") {
                if (this.start_h === "23") {
                  vm.date_end = new Date(
                    new Date(this.date_start).setDate(
                      new Date(this.date_start).getDate() + 1
                    )
                  )
                    .toISOString()
                    .substring(0, 10);
                  vm.$refs.menu_e.save(vm.date_end);
                  vm.hour_end = this.hour_start;
                  vm.min_end = this.min_start;
                  vm.end_h = "00";
                  vm.end_m = "00";
                } else {
                  vm.end_h = filterH[filterH.indexOf(this.start_h) + 1];
                  // vm.hour_end.shift();
                  vm.min_end = this.hour_start;
                  vm.end_m = "00";
                }
              } else {
                vm.end_m = filterM[filterM.indexOf(this.start_m) + 1];
              }
            } else {
              let filterMWithZero = this.min_start.filter(
                (a) => a > this.start_m
              );
              vm.min_end = filterMWithZero;
            }
          } else {
            vm.min_end = this.min_start;
          }
          a = false;
        } else {
          vm.hour_end = this.hour_start;
          vm.min_end = this.min_start;
        }
      } else {
        a = true;
      }
      this.$emit("setstartend", {
        date_start: this.date_start,
        start_h: this.start_h,
        start_m: this.start_m,
        date_end: this.date_end,
        end_h: this.end_h,
        end_m: this.end_m,
      });
      return a;
    },
  },
  methods: {
    ClearTime() {
      if (!this.surveyform.enableSchedule) {
        this.surveyform.surveyDatetimeStart = "";
        this.surveyform.surveyDatetimeEnd = "";
        this.start_h = "00";
        this.start_m = "00";
        this.end_h = "00";
        this.end_m = "01";
        this.date_start = null;
        this.date_end = null;
      }
    },
    DateStartFormat() {
      this.surveyform.surveyDatetimeStart = `${this.date_start}T${this.start_h}:${this.start_m}`;
      if (!this.surveyform.enableSchedule) {
        this.surveyform.surveyDatetimeStart = new Date().toISOString();
      }
    },
    DateEndFormat() {
      this.surveyform.surveyDatetimeEnd = `${this.date_end}T${this.end_h}:${this.end_m}`;
      if (!this.surveyform.enableSchedule) {
        this.surveyform.surveyDatetimeEnd = new Date().toISOString();
      }
    },
    StartSave() {
      this.$refs.menu_s.save(this.date_start);
      let start = new Date(this.date_start).getTime();
      let end = new Date(this.date_end).getTime();
      if (start > end) {
        this.date_end = this.date_start;
        this.end_h = "00";
        this.end_m = "01";
      }
      this.menu_start = false;
      this.DateStartFormat();
    },
    EndSave() {
      this.$refs.menu_e.save(this.date_end);
      this.menu_end = false;
      this.DateEndFormat();
    },
    Submit() {
      if (this.$refs.form.validate()) {
        this.surveyform.surveyDatetimeStart = `${this.date_start}T${this.start_h}:${this.start_m}`;
        this.surveyform.surveyDatetimeEnd = `${this.date_end}T${this.end_h}:${this.end_m}`;
        if (!this.surveyform.enableSchedule) {
          this.surveyform.surveyDatetimeStart = new Date().toISOString();
          this.surveyform.surveyDatetimeEnd = new Date().toISOString();
        }
        this.$emit("submit");
      }
    },
  },
};
</script>
